<template>
  <h2 class="subtitle is-spaced" :class="getTitleClass(size, lineSeparator)">
    <slot></slot>
  </h2>
</template>

<script>
  export default {
    name: 'subtitle-component',
    props: {
      size: {
        type: Number,
        default: 3
      },
      lineSeparator: {
        type: String,
        default: ''
      }
    },
    methods: {
      getTitleClass: function (size, lineSeparator) {
        return 'line-' + lineSeparator + ' is-' + size
      }
    }
  }
</script>
